import styled from '@emotion/styled';

export const ChartContainer = styled.div`
	width: 100%;
	height: ${({ entries, isHorizontal }) => (isHorizontal ? (entries ? `${entries * 7 + 10}rem` : '30rem') : 'unset')};
`;
